import { ROUTES } from '../../../routes';

export const SubmenuFormation = (indexToColor?: string) => {
  return [
    {
      label: 'Définitions',
      link: ROUTES.FORMATION.DEFINITIONS,
      content: ' ...',
      color: indexToColor === '1' ? true : false,
    },
    {
      label: 'Obligations',
      link: ROUTES.FORMATION.OBLIGATION,
      content: ' ...',
      color: indexToColor === '2' ? true : false,
    },
    {
      label: 'Marché financiers',
      link: ROUTES.FORMATION.FINANCIER,
      content: ' ...',
      color: indexToColor === '3' ? true : false,
    },
    {
      label: 'MoranjEtrade',
      link: ROUTES.FORMATION.MORANJE,
      content: ' ...',
      color: indexToColor === '4' ? true : false,
    },
    {
      label: 'Marché interbancaire',
      link: ROUTES.FORMATION.INTERBANCAIRE,
      content: ' ...',
      color: indexToColor === '5' ? true : false,
    },
    {
      label: 'Fiscalité & Compta',
      link: ROUTES.FISCA.PAGE,
      content: ' ...',
      color: indexToColor === '6' ? true : false,
    },
    {
      label: 'Règlementation',
      link: ROUTES.REGLEMENTATION.REGION,
      content: ' ...',
      color: indexToColor === '7' ? true : false,
    },
  ];
};
